/** @module csi/toolbar/_SelectSwitchboard */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/aspect",
	"dijit/_TemplatedMixin",
	"dijit/_Widget",
	"dijit/_WidgetsInTemplateMixin",
	"csi/_base/Deferred",
	"csi/_base/underscore",
	"csi/action/Popup",
	"csi/def",
	"csi/def/AddPath",
	"csi/def/Relationship",
	"csi/html",
	"csi/locale",
	"csi/session",
	"csi/state/rootStore",
	"csi/store/_base",
	"csi/store/Names",
	"csi/view/ToolbarPlugin",
	"csi/xml",
	"dojo/text!csi/templates/pluginSwitchboard.html"
], function(declare, lang, aspect, _TemplatedMixin, _Widget, _WidgetsInTemplateMixin, csiDeferred, _, Popup, def, AddPath,
	Relationship, html, locale, session, {routerStore}, csiStore, Names, ToolbarPlugin, xml, template) {

	var ID_URLROOT = "urlRoot";

	return declare([_Widget, _TemplatedMixin, _WidgetsInTemplateMixin, ToolbarPlugin], {
		// html template for plugin
		templateString: template,

		// connection points
		buttonNode: null,
		goNode: null,
		labelNode: null,
		selectNodeContainer: null,

		// relationship
		_rel: null,

		// Boolean: Hides the Go button next to the switchboard
		hideGo: false,

		// Boolean: set to true to wait for view to load before initializing plugin - in some cases this will reduce queries since
		// the data for the switchboard may already be cached
		//bDelayInitialization: false,

		// Action: action to invoke when popup button is pressed
		//buttonAction: null,

		//Boolean: boolean to set to disable the popup
		//disableButtonAction: false,

		// String: property to set on view when value changes
		//idViewProperty: null,

		/** @property {string} label - label appearing to left of the switchboard */
		label: "",

		// Number: customize page size for switchboard
		//pageSize: null,

		// String: set placeholder for select widget
		//placeHolder: null,

		//Boolean: boolean to refresh store options when store is refreshed
		//refreshStoreOptions: false,

		// Function: class to use to create select widget
		//selectClass: null,

		// Widget: either single or multiple select widget
		//selectNode: null,

		// Store: store for selectNode
		//store: null,

		// String: path to use for store - filled in by derived class (supports ExtendedPath)
		//switchboardPath: "",

		// String: value for selectNode
		//value: null,

		// Boolean: indicates if button action is currently running
		//_bButtonActive: false,

		// Boolean: indicates store is empty and select should be disabled
		//_bEmptyStore: false,

		// Boolean: indicates if should trigger onChange event; default value is null so that onChange not invoked first time through
		_onChangeActive: null,

		// Object: options used to construct store
		//_storeOptions: null,

		enablePlugin: function(/*Context?*/ctx) {
			// summary: actions do not edit, so enable or disable based on if context is present
			var bDisable = !ctx || !this._hasAccessToAction(ctx);
			this._setDisabled(this.selectNode, bDisable || this._bEmptyStore);
			this._setDisabled(this.buttonNode, bDisable || !this.buttonAction || !this.buttonAction.hasAccess(ctx));
			this._setDisabled(this.goNode, bDisable || !this._canGo(ctx));
		},

		getViewPropertyValue: function() {
			// summary: if this switchboard is configured to update a view property, then return its current value
			if (this.idViewProperty) {
				return this.getView().get(this.idViewProperty);
			}

			return null;
		},

		onChangeValue: function(/*csi.view.Widget*/view, /*Any*/value) {
			// summary: extension point to react to value change
		},

		onRefresh: function() {
			// summary: extension point to refresh store and/or value
		},

		onSelectParams: function(/*Object*/params) {
			// summary: extension point to add options for select widget
		},

		postMixInProperties: function() {
			// summary: set appearance based on action
			this._mixinActionProperties();
			this.inherited(arguments);
		},

		postCreate: function() {
			// summary: set store for select control
			this.inherited(arguments);

			var view = this.getView();
			var url = view.getViewURL();
			var a = this.defAction;
			var vr = a.m_viewRef;
			var lr = locale.localeResolver;
			var bLabel = !vr || this.disableButtonAction;
			var r;

			if (vr) {
				// get switchboard relationship from referenced view
				vr.m_url = vr.m_url || url;

				if (!this.switchboardPath) {
					var node = vr.getReferencedNode(view.cacheView, view.getViewNode());
					var defView = def.getNodeViewDef(node, vr.m_id);
					if (defView) {
						if (r = defView.getPageRelationship()) {
							r.m_url = r.m_url || node.$URL;
							this._rel = r;
						}
					}
				}
			}

			if (bLabel) {
				// hide button if just showing a label
				this.buttonNode.set("disabled", true);
				html.setVisible(this.buttonNode, false);
			} else {
				// setup button action
				var ba = this.buttonAction = this._getButtonAction(lr);
				ba.m_postAction = lang.hitch(this, "_postClickButton");
				ba.resolve(lr, a.m_rcTarget);
				this._mixinActionProperties(this.buttonNode, ba);
			}

			// hide label if none provided
			if (!bLabel || !this.label) {
				html.setVisible(this.labelNode, false);
			}

			// setup select control
			var selectParams = {};
			var typeNode;

			this.onSelectParams(selectParams);
			selectParams.disabled = true;
			selectParams.onChange = lang.hitch(this, this._onChangeSelect);

			if (this.store) {
				selectParams.store = this.store;
				typeNode = this.store.typeNode;
			} else if (this._storeOptions = this._getStoreOptions(url, r)) {
				typeNode = this._storeOptions.typeNode;
			}

			if (a.m_tooltip) {
				selectParams.title = a.m_tooltip;
			}

			if (this.pageSize) {
				selectParams.pageSize = this.pageSize;
			}

			if (this.placeHolder) {
				selectParams.placeHolder = locale.resource(this.placeHolder);
			}

			this.selectNode = new this.selectClass(selectParams).placeAt(this.selectNodeContainer);

			// hide Go node if cannot navigate to switchboard item - does not make sense to navigate to multiple
			if (this.hideGo || a.bMultipleAll || a.bMultipleNone || !def.canNavigateToType(typeNode)) {
				html.setVisible(this.goNode, false);
			}

			// if controlled by property on view, then update value when it changes
			if (this.idViewProperty) {
				view.watch(this.idViewProperty, lang.hitch(this, this._onWatchViewProperty));
			}

			// make sure that deleted nodes are removed from switchboard
			this.own(aspect.after(view.cacheView, "onDelete", lang.hitch(this, this._onDeleteNode), true));

			if (this.bDelayInitialization) {
				// wait for view to load and only then set store
				view.getDeferred().then(lang.hitch(this, this._onDelayedStart));
			} else {
				// set store and value unless delaying until after view is first loaded
				if (!this.get("store")) {
					this.set("store");
				}

				if (!this.get("value")) {
					this._deferred = new csiDeferred();
					this.set("value", this.getViewPropertyValue());
				}
			}
		},

		refreshStore: function(/*Any?*/value, /*Boolean?*/bDefault) {
			// summary: reset store and value if given or if default specified
			this.onRefresh();

			if (this.refreshStoreOptions) {
				this._storeOptions = this._getStoreOptions(this.getView().getViewURL(), this._rel);
			}

			// if a spurious deferred showed up
			if (this._deferred) {
				this._deferred = null;
			}

			this.set("store");

			if (value || bDefault) {
				this._deferred = new csiDeferred();
				this.set("value", value);
			}

			return this._deferred;
		},

		_canGo: function(/*Context?*/ctx) {
			// summary: determine if can navigate to currently selected node - does not apply to multiple switchboard case
			const url = this.get("value");
			return _.isString(url) && xml.isValidURL(url) && (url != routerStore.locationUrl);
		},

		_getButtonAction: function(/*LocaleResolver*/lr) {
			// summary: create action for button - default is to popup view of switchboard items
			var a = this.defAction;

			return lang.mixin(new Popup(), {
				m_id: a.m_id + "Popup",
				m_name: a.m_name,
				m_tooltip: locale.resource("SwitchboardPopup_TT", a._getNameParams(lr)),
				m_viewRef: a.m_viewRef
			});
		},

		_getStoreOptions: function(/*String*/url, /*Relationship?*/r) {
			// summary: default store is that of parent's reverse relation
			var view = this.getView();
			var ctx = view.getContext(url);
			var bTestPath;

			if (!r) {
				r = lang.mixin(new Relationship(), {
					m_addPaths: [lang.mixin(new AddPath(), {
						m_path: this.switchboardPath
					})],
					m_sorts: this.switchboardSortAttr ? [{id: this.switchboardSortAttr}] : null
				});

				bTestPath = true;
			}

			if (this.defAction.m_fixedQuery) {
				r.addFilters(this.defAction.m_fixedQuery ? this.defAction.m_fixedQuery.getElements() : null, ctx.cache, view.getViewNode());
				bTestPath = false;
			}

			var options = csiStore.namesOptionsByRelationship(ctx, r);

			// if path and no query, then determine if nodes already cached
			// FIX - eventually this logic can move to Names store (as in Nodes)
			if (bTestPath) {
				var nodes = ctx.cache.getPathNodes(ctx.getNode(), this.switchboardPath, view.get("refreshTimestamp"), true);
				if (nodes) {
					options.request = null;
					options.data = _.map(nodes, function(node) {
						return csiStore.nameObject(node, null, ctx.cache);
					});

					// options are based on current conditions, so need to refresh options next time they are needed (when store is refreshed)
					this.refreshStoreOptions = true;
				}
			}

			return options;
		},

		_onClickButton: function(/*Event*/e) {
			// summary: popup view
			this._bButtonActive = true;
			this.onClick(e, this.buttonAction);
		},

		_onChangeSelect: function(/*Any*/value) {
			// summary: respond to change to selectNode
			this._setSwitchboardValue(value);
		},

		_onChangeValue: function(/*Any*/value) {
			// summary: notify listeners of change
			var view = this.getView();
			var id = this.idViewProperty;

			// NOTE: don't set urlRoot directly from here - instead need to use setViewNode (until we refactor to allow this to work)
			if (id && (id != ID_URLROOT)) {
				// update property in view if specified; do an extra check to see if there really was a change - the select control
				// could falsely be reporting a change when the values are equal
				var viewValue = (value && value.length) ? value : null;

				if (this._onChangeActive && _.isEqual(viewValue, view.get(id))) {
					return;
				}

				view.set(id, viewValue);
			}

			// call extension point to process new value
			this.onChangeValue(view, value);

			// invoke action if widget active and view not already in process of loading (waiting for toolbar to finish initializing);
			// in other words, only invoke action when initiated by user rather than by initializing widget with values
			if (this._onChangeActive && !view.isLoadingView()) {
				this.onChange(value, this.defAction);
			}
		},

		_onDelayedStart: function() {
			// summary: initialize store
			this.refreshStore(this.getViewPropertyValue(), true);
		},

		_onDeleteNode: function(/*String*/url) {
			// summary: refresh store if url is current value
			if (!this._bButtonActive && (url == this.get("value"))) {
				this.refreshStore(null, true);
			}
		},

		_onGo: function(/*Event*/e) {
			// summary: navigate to currently selected item
			session.setLocationUrl(this.get("value"));
		},

		_onWatchViewProperty: function(/*String*/attr, /*String*/oldVal, /*String*/newVal) {
			// summary: update select node with new value for property - Dojo's watch function does not test
			// for equality of array values, so only update the value if there is really a change; also make
			// sure null and undefined are treated equally
			if (!_.isEqual(oldVal || null, newVal || null)) {
				this.set("value", newVal);
			}
		},

		_postClickButton: function(/*Controller*/ac) {
			// summary: refresh store
			this.refreshStore(null, this._valueIsInvalid());
			this._bButtonActive = false;
		},

		_resolveDeferred: function() {
			// summary: resolve deferred if it exists and reset _onChangeActive flag if first time through
			if (this._onChangeActive === null) {
				this._onChangeActive = true;
			}

			if (this._deferred) {
				this._deferred.resolve();
				this._deferred = null;
			}
		},

		/**
		 * Update label shown for switchboard
		 * @param {string} value
		 */
		_setLabelAttr: function(value) {
			this._set("label", value);
			this.buttonNode.set("label", value);
			html.setInnerText(this.labelNode, value);
		},

		_setSelectNodeValue: function(/*String?*/value) {
			// summary: set value for select widget - need to abstract into function because of different interface for multi-select widget (ugh!)
			this.selectNode.set("value", value);
		},

		_setSwitchboardValue: function(/*Any*/value) {
			// summary: update setting on view indicating currently selected node
			if (this._valueIsInvalid(value)) {
				this.onRefresh();
				this.set("store");
				this.set("value");
			} else {
				var oldValue = this.value;

				// make sure empty value and empty array are considered the same
				if (_.isArray(value) && !oldValue) {
					oldValue = [];
				}

				if (value && !_.isEqual(value, oldValue)) {
					this._set("value", value);
					this._onChangeValue(value);
				}

				this._resolveDeferred();
			}
		},

		_setStoreAttr: function(/*Store?*/store) {
			// summary: reset store on select node - if none given, then create one
			if (!store && this._storeOptions) {
				store = new Names(this._storeOptions);
			}

			this._bEmptyStore = !store;
			this._set("store", store);

			if (store) {
				this.getView().annotateViewStore(store);
			}

			if (this.selectNode) {
				this.selectNode.set("store", store);
			}
		},

		_setValueAttr: function(/*String?*/value) {
			// summary: set value on select node - if none given, then select default value
			if (this.store && !_.isEqual(value, this.value)) {
				this._setSelectNodeValue(value);
			} else {
				this._resolveDeferred();
			}
		},

		_valueIsInvalid: function(/*Any?*/value) {
			// summary: determine if selected value(s) remain in cache
			var cache = this.getView().cacheView;

			value = value || this.get("value");

			if (!_.isArray(value)) {
				value = [value];
			}

			return _.some(value, cache.isDeleted, cache);
		}
	});
});